<template>
  <div
    class="cart-item-counter"
    :class="['cart-item-counter--' + size]"
  >
    <button
      class="cart-item-counter__button cart-item-counter__button--decrement"
      :disabled="quantity <= 1"
      @click.prevent="decrementQuantity"
      :title="$t('cart_product_decrement')"
    >
      <svg
        fill="currentColor"
        width="16"
        height="2"
        viewBox="0 0 16 2"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          width="16"
          height="1.5" />
      </svg>
    </button>
    <input
      class="cart-item-counter__input"
      v-model.number.trim="quantity"
      @input="handleQuantity(500)"
      @blur="quantity = productQuantity"
      type="number"
      min="1" />
    <button
      class="cart-item-counter__button cart-item-counter__button--increment"
      :disabled="quantity >= productMaxQuantity"
      @click.prevent="incrementQuantity"
      :title="$t('cart_product_increment')"
    >
      <svg
        fill="currentColor"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          y="7.27271"
          width="16"
          height="1.45455" />
        <rect
          x="7.27246"
          y="16"
          width="16"
          height="1.45455"
          transform="rotate(-90 7.27246 16)" />
      </svg>
    </button>
  </div>
</template>

<script>
// Компонент изменения количества товаров в корзине
// Принимает обязательные пропсы productQuantity и productMaxQuantity
// Принимает не обязательный пропс size (small, regular) по дефолту regular
// При изменении количества возвращает событие changeQuantity с текущим количеством (quantity)

import { debounce } from '@/mixins'

export default {
  name: 'CartItemCounter',
  mixins: [debounce],
  data () {
    return {
      quantity: this.productQuantity
    }
  },
  props: {
    productQuantity: {
      type: [Number, String],
      required: true
    },
    productMaxQuantity: {
      type: [Number, String],
      required: true
    },
    size: {
      type: String,
      default: 'regular'
    }
  },
  methods: {
    incrementQuantity () {
      this.quantity++
      this.handleQuantity()
      // this.$emit('increment')
    },
    decrementQuantity () {
      this.quantity--
      this.handleQuantity()
      // this.$emit('decrement')
    },
    handleQuantity (debounceDelay = 300) {
      if (this.quantity === '') return
      if (this.quantity >= this.productMaxQuantity) {
        this.quantity = this.productMaxQuantity
      } else if (this.quantity <= 0) {
        this.quantity = 1
      }

      this.quantity = Math.round(this.quantity)
      this.debounce(() => this.$emit('changeQuantity', this.quantity), debounceDelay)
    }
  },
  watch: {
    productQuantity: {
      immediate: true,
      handler (value) {
        this.quantity = value
      }
    },
    quantity (curr, prev) {
      if (curr > prev) {
        this.$emit('increment', { curr, prev })
      } else {
        this.$emit('decrement', { curr, prev })
      }
    }
  }
}
</script>

<style scoped lang="sass">
.cart-item-counter
  display: flex
  align-items: center
  border: 1px solid $nd-border-color
  border-radius: 3px
  max-width: max-content

  &:hover
    border-color: rgba(144, 144, 144, 0.5)

.cart-item-counter__button
  display: flex
  justify-content: center
  align-items: center
  width: 24px
  height: 28px
  color: $text-color
  border: 0
  outline: 0
  background: transparent
  margin: 0
  padding: 0
  overflow: visible
  cursor: pointer

  +mmin($tablet--hor)
    width: 40px
    height: 40px

  &:hover
    background-color: #F8F8F8

    &:focus
      color: $main-color

  &:disabled
    pointer-events: none

    svg
      opacity: 0.3

  &--decrement
    border-right: 1px solid $nd-border-color

  &--increment
    border-left: 1px solid $nd-border-color

  svg
    width: 10px

    +mmin($tablet--hor)
      width: 16px

.cart-item-counter__input
  color: $text-color
  font-size: 16px
  width: 32px
  height: 28px
  border: 0
  outline: 0
  overflow: visible
  text-align: center
  -moz-appearance: textfield
  background: transparent

  +mmin($tablet--hor)
    font-size: 18px
    width: 40px
    height: 40px

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0

.cart-item-counter--small
  .cart-item-counter__button
    width: 24px
    height: 28px

    svg
      width: 10px

  .cart-item-counter__input
    font-size: 16px
    width: 32px
    height: 28px
</style>
